import { render, staticRenderFns } from "./invoice-context.vue?vue&type=template&id=68b116aa&"
import script from "./invoice-context.vue?vue&type=script&lang=js&"
export * from "./invoice-context.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports